<div class="skeleton-grid" aria-busy="true" aria-label="loading">
  @for (i of skeletonItems; track i) {
  <article class="skeleton-card">
    <!-- <div class="skeleton-card__image-wrapper">
      <div class="skeleton-card__image skeleton-shimmer"></div>
    </div> -->
    <div class="skeleton-card__content">
      <div class="skeleton-card__title skeleton-shimmer"></div>
      <div class="skeleton-card__title-short skeleton-shimmer"></div>
      <div class="skeleton-card__meta">
        <div class="skeleton-card__meta-item">
          <div class="skeleton-card__icon skeleton-shimmer"></div>
          <div class="skeleton-card__text skeleton-shimmer"></div>
        </div>
        <div class="skeleton-card__meta-item">
          <div class="skeleton-card__icon skeleton-shimmer"></div>
          <div class="skeleton-card__text-short skeleton-shimmer"></div>
        </div>
      </div>
    </div>
  </article>
  }
</div>